<template>
    <div class="specialDiv">
        <div class="bolim account">
            <h1>
                Account Edit:
            </h1>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
/* General styles */
* {
    margin: 0;
    padding: 0 auto;
}


.specialDiv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.bolim {
    width: 100%;
    height: calc(100vh - 120px);
}
button {
    margin-top: 100px;
}

/* #################### */

/* Account Edit`s styles */

/* #################### */



/* Selecte Language`s styles */
.forLanguage {
    width: 230px;
    display: flex;
    align-items: center;
    text-align: center;
    margin-top: 20px;
    /* border: 1px solid red; */
    margin-left: 75px;
}

.forLanguage input {
    max-width: 15px;
    min-height: 15px;
    max-height: 25px;
    margin: 0;
    padding: 0;
}

.forLanguage label {
    margin-left: -20px;
    font-size: 24px;
}

#top1 {
    margin-top: 100px;
}

/* #################### */
</style>